import { WorkloadReport } from './types';

export function recoveryWarnings(report: WorkloadReport, text: (key: string, values?: Record<string, unknown>) => string): string[] {
  const recovery = report.source?.recovery;
  if (!recovery || Date.parse(report.range.from) >= Date.parse(recovery.to) || Date.parse(report.range.to) <= Date.parse(recovery.from)) return [];
  return [
    text('recoveryHistory', { cases: recovery.cases, unavailable: recovery.unavailable }),
    ...(recovery.status !== 'complete' ? [text('recoveryApplying')] : []),
    text(recovery.goalMode === 'current' ? 'recoveryCurrentGoals' : 'recoveryUnknownGoals'),
  ];
}

export function recoveryPending(report: WorkloadReport): boolean {
  return report.source?.recovery?.status === 'applying' && recoveryWarnings(report, (key) => key).length > 0;
}
